export const QUERY = {
  AFTER_TEST: 'after_test'
} as const;